import React from 'react';
import { ComplianceDialogs } from '../../constants/Dialogs';
import { asDialog } from '../Common/Decorators';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { clearAssignedUsers } from '../../actions/ComplianceActionCreator';
import DialogActions from "../../actions/DialogActionCreator";

const ComplianceClearUsersDialog = ({open, draft}) => {
    const { complianceId, userCount = 0 } = draft;
    if (!complianceId) { return null; } //guard: complianceId is required
    return (
        <Dialog
            title="Clear assigned users"
            open={open === ComplianceDialogs.COMPLIANCE_CLEAR_USERS}
            actions={[
                <FlatButton key="cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
                <FlatButton
                    primary={true}
                    key="submit"
                    label="Clear"
                    onTouchTap={() => {clearAssignedUsers(complianceId); DialogActions.close();}}
                />
            ]}
        >
            This action will remove {userCount > 1 ? `${userCount} users` : '1 user'} from this compliance
        </Dialog>
    );
};

export default asDialog(ComplianceClearUsersDialog, ComplianceDialogs.COMPLIANCE_CLEAR_USERS);
